






import Vue from "vue";
import DocOCR from "@tecnike/dococr";

export default Vue.extend({
  data () {
    return {
      scanPromise: new Promise(() => null) as Promise<DocOCR.DocOCRResult>
    };
  },

  async mounted (): Promise<void> {
    await this.initialiseDocOcrAsync();

    this.docOcr.addEventListener("document-scanned", this.onDocumentScanned);

    this.scanPromise = this.scanAsync();
  },

  beforeDestroy () {
    this.docOcr.removeEventListener("document-scanned", this.onDocumentScanned);
    this.docOcr.stop();
    this.docOcr.close();
  },

  methods: {
    async onDocumentScanned (event: Event): Promise<void> {
      event.preventDefault();
      this.$q.loading.show();

      this.docOcr.stop();
      this.docOcr.style.display = "none";
      const result = await this.scanPromise;
      this.$store.commit("scanResult-set", result);

      this.$q.loading.hide();
      this.$router.push("/new-customer-data");
    },

    async initialiseDocOcrAsync (): Promise<void> {
      this.$q.loading.show();
      this.docOcr.init();
      await this.docOcr.open();
      this.$q.loading.hide();
    },

    async scanAsync (): Promise<DocOCR.DocOCRResult> {
      const result = await this.docOcr.start();
      this.$q.loading.hide();
      return result;
    },

    stopScanning (): void {
      this.docOcr.stop();
      this.$q.loading.show();
    }
  },

  computed: {
    docOcr (): DocOCR.DocOCRWebComponent {
      return document.querySelector("doc-ocr") as DocOCR.DocOCRWebComponent;
    }
  }
});
